/*
 *
 * Virtual Market
 * general-utils -> Funciones utilitarias generales
 *
 * RYNDEM 2017
 *
 */

import counterpart from 'counterpart'
import accounting from 'accounting'
import moment from 'moment'
import protocols from 'common-protocols'

import _ from 'lodash'
import { DEBUG } from 'common-protocols'

const OBJECT_ID = 'general-utils'

export const translate = termKey => counterpart(termKey);

export const formatNumber = (number, precision) => accounting.formatNumber(number, precision);

export const formatMoney = quantity => accounting.formatMoney(quantity);

export const setAppLanguage = locale => { counterpart.setLocale(locale) };

export const getAppLanguage = () => counterpart.getLocale();

export const onScroll = () => { document.getElementsByTagName("html")[0].style.overflow = "auto" /*document.body.setAttribute('style', 'overflow:auto')*/ };

export const offScroll = () => { document.getElementsByTagName("html")[0].style.overflow = "hidden" /*document.body.setAttribute('style', 'overflow:hidden')*/ };

const URL_IMG = "http://mercado.virtual.sekaisoft.com.mx/_productos";

export const validator = {
  decimalNumber : /^[0-9]+\.?[0-9]*$/,
  number : /^[0-9]+$/,
  alpha : /^[a-zA-ZñÑáÁéÉíÍóÓúÚçÇ ]*$/,
  alphaNumeric : /^[a-zA-ZñÑáÁéÉíÍóÓúÚçÇ0-9\n\.\,\'\"\-]+( *[a-zA-ZñÑáÁéÉíÍóÓúÚçÇ0-9\n\.\,\'\"\-]+)*$/,
  email : /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i
};

export function isWindowResizeValid() {

  return window.innerWidth < 980;
}

export function initializeAccountingSettings(currencyCode) {

  // moneda por defailt "MXN"
  let currencyToUse = {
    "symbol": "MX$",
    "nameEN": "Mexican Peso",
    "nameES": "Peso Mexicano",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    money_thousand_separator: ",",
    money_decimal_separator : ".",
    num_thousand_separator: ",",
    num_decimal_separator : ".",
    "name_pluralEN": "Mexican pesos",
    "name_pluralES": "Pesos Mexicanos"
  };

  //establecemos valores por default de librería de números accounting
  let symbol = (typeof currencyToUse !== 'undefined') ?
    currencyToUse.symbol_native : '';
  let currentCurrencyThousandSeparator = (typeof currencyToUse !== 'undefined') ?
    (currencyToUse.money_thousand_separator ?
      currencyToUse.money_thousand_separator : ',' ) : ',';
  let currentCurrencyDecimalSeparator = (typeof currencyToUse !== 'undefined') ?
    (currencyToUse.money_decimal_separator ?
      currencyToUse.money_decimal_separator : '.' ) : '.';
  let currentNumberThousandSeparator = (typeof currencyToUse !== 'undefined') ?
    (currencyToUse.num_thousand_separator ?
      currencyToUse.num_thousand_separator : ',' ) : ',';
  let currentNumberDecimalSeparator = (typeof currencyToUse !== 'undefined') ?
    (currencyToUse.num_decimal_separator ?
      currencyToUse.num_decimal_separator : '.' ) : '.';
  let currentNumberDecimalDigits = (typeof currencyToUse !== 'undefined') ?
    ((currencyToUse.hasOwnProperty('decimal_digits') && currencyToUse.decimal_digits) > -1 ?
      currencyToUse.decimal_digits : 2 ) : 2;

  accounting.settings = {
    currency: {
      symbol : symbol,
      format: "%s%v",
      decimal : currentCurrencyDecimalSeparator,
      thousand: currentCurrencyThousandSeparator,
      precision : currentNumberDecimalDigits
    },
    number: {
      precision : 0,  // default precision on numbers is 0
      thousand: currentNumberThousandSeparator,
      decimal : currentNumberDecimalSeparator
    }
  };

};

export function scrollTop() {
  //posiciona el scroll al inicio
  let container = document.body;
  container.scrollTop = 0;

  container = document.documentElement;
  container.scrollTop = 0;

  container = window.pagYOffset;
  container = 0;

  container = window.scrollY;
  container = 0;
}

export function handlerCheckRadio(collection, option, data = null) {

  _.forIn( collection, (value, key) => {
    if(key === option && key !== 'value') {
      collection[key] = value === false ? !value : true;
    } else if (key !== 'id' && key !== 'answersSelected' && key !== 'value') {
      collection[key] = false;
    } else if (key === 'value') {
      collection[key] = data;
    }
  });

};

export function handlerCheckBox(collection, option, validateOption = '', prefix = '') {

  _.forIn( collection, (value, key) => {

    if(key === option) {
      collection[key] = !value;
    }

    if (key === validateOption && validateOption !== '' && collection[key] === true) {
      collection[key] = false;
      const id = key + prefix;
      let element = document.getElementById(id);
      reset( element );
    }

  });

}

export function handlerCheckBoxValidate(collection, option, prefix = '') {

  _.forIn( collection, (value, key) => {

    if( key !== option && typeof collection[key] == 'boolean' && collection[key] === true ) {
      collection[key] = false;
        const id = key + prefix;
      let element = document.getElementById(id);
      reset( element );

    } else if(key === option) {
      collection[key] = !value;
    }

  });

}

export function handlerCheckBoxStorage(collection, optionValidate, option ) {
  let array = collection.slice();
  _.forEach(collection, item => {

    const index = _.findIndex(array, o => o.option === item.option);

    if ( optionValidate ) {
      if (item.option !== option) {
        array.splice(index, 1);
      }
    } else {
      if (item.option === option) {
        array.splice(index, 1);
      }
    }

  });

  return array;

}

export function patchAnswers(collection) {
  _.forEach(collection, object => {
    _.forIn(object, (item, key) => {
      if (key === 'opciones') {
        _.forIn(item, value => {
          value.answer = false
        })
      }
    })
  })
};

export function applyImagesToProductsInCart(cart, products){
  let cartWithImages = cart.map(productInCart => {
    const fullProduct = products.find( product => product.idProducto == productInCart.idProducto);
    if(!!fullProduct){
      return {
        ...productInCart,
        img: fullProduct.img,
        card: fullProduct.card,
        imageLabel: fullProduct.imageLabel
      }
    }
    return productInCart;
  })
  return cartWithImages;
}

export function matchAnswersQuestionnaireSalida(stateAnswers, answers) {
  return stateAnswers.map((answer, index) => ({
    ...answer,
    [answers[index].option] : true,
    answersSelected: [{
      idOpcion: answers[index].idOpcion,
      valor: answers[index].valor,
      option: answers[index].option,
      indice: answers[index].indice
    }]
  }));
};

export function addImagesToProducts(collection, idMarket){
  const { beverages, snacks, cereals, dairyProducts, readyToEat } = getProductsByDepartment(collection, true, idMarket);
  let products = [...beverages, ...snacks, ...cereals, ...dairyProducts, ...readyToEat];
  return products;
}

export function getProductsByDepartment(collection, addQty = false, idMarket) {

  let num = 0;
   num++;

  collection.sort( (a , b) => a.idProducto - b.idProducto );
  let beverages = [], snacks = [], cereals = [], dairyProducts = [], readyToEat = [];

    let beveragesIndex = 1;
    let snacksIndex = 1;
    let cerealsIndex = 1;
    let dairyProductsIndex = 1;
    let readyToEatIndex = 1;

  _.forEach(collection, (o, index) => {

    if(!addQty) {
      o.quantity = 1;
    }

    const department = o.departamento.toLowerCase();


    switch (o.departamento) {
      case 'Bebidas':
        o.img = `${URL_IMG}/${department}/${beveragesIndex}.png`;
        o.card = `${URL_IMG}/${department}/${idMarket}/close-upsficha/${beveragesIndex}.png`;
        o.cardControl = `${URL_IMG}/${department}/6/close-upsficha/${beveragesIndex}.png`;
        o.imageLabel = `${URL_IMG}/${department}/${idMarket}/${beveragesIndex}.png`;
        o.imageLabelControl = `${URL_IMG}/${department}/6/${beveragesIndex}.png`;
        beverages.push(o);
        beveragesIndex++;
        break;
      case 'Botanas':
        o.img = `${URL_IMG}/${department}/${snacksIndex}.png`;
        o.card = `${URL_IMG}/${department}/${idMarket}/close-upsficha/${snacksIndex}.png`;
        o.cardControl = `${URL_IMG}/${department}/6/close-upsficha/${snacksIndex}.png`;
        o.imageLabel = `${URL_IMG}/${department}/${idMarket}/${snacksIndex}.png`;
        o.imageLabelControl = `${URL_IMG}/${department}/6/${snacksIndex}.png`;
        snacks.push(o);
        snacksIndex++;
        break;
      case 'Cereales':
        o.img = `${URL_IMG}/${department}/${cerealsIndex}.png`;
        o.card = `${URL_IMG}/${department}/${idMarket}/close-upsficha/${cerealsIndex}.png`;
        o.cardControl = `${URL_IMG}/${department}/6/close-upsficha/${cerealsIndex}.png`;
        o.imageLabel = `${URL_IMG}/${department}/${idMarket}/${cerealsIndex}.png`;
        o.imageLabelControl = `${URL_IMG}/${department}/6/${cerealsIndex}.png`;
        cereals.push(o);
        cerealsIndex++;
        break;
      case 'Lácteos':
        o.img = `${URL_IMG}/${department}/${dairyProductsIndex}.png`;
        o.card = `${URL_IMG}/${department}/${idMarket}/close-upsficha/${dairyProductsIndex}.png`;
        o.cardControl = `${URL_IMG}/${department}/6/close-upsficha/${dairyProductsIndex}.png`;
        o.imageLabel = `${URL_IMG}/${department}/${idMarket}/${dairyProductsIndex}.png`;
        o.imageLabelControl = `${URL_IMG}/${department}/6/${dairyProductsIndex}.png`;
        dairyProducts.push(o);;
        dairyProductsIndex++;
        break;
      case 'Listos':
        o.img = `${URL_IMG}/${department}/${readyToEatIndex}.png`;
        o.card = `${URL_IMG}/${department}/${idMarket}/close-upsficha/${readyToEatIndex}.png`;
        o.cardControl = `${URL_IMG}/${department}/6/close-upsficha/${readyToEatIndex}.png`;
        o.imageLabel = `${URL_IMG}/${department}/${idMarket}/${readyToEatIndex}.png`;
        o.imageLabelControl = `${URL_IMG}/${department}/6/${readyToEatIndex}.png`;
        readyToEat.push(o);
        readyToEatIndex++;
        break;
      default: break;
    }

  });

  return ({ beverages, snacks, cereals, dairyProducts, readyToEat });
}

export function getProductsByBenefit(collection) {

  let muySaludables = [], saludables = [], noSaludables = [];

  _.forEach(collection, (value, key) => {
    _.forEach(value, (value) => {
      switch (value.beneficio) {
        case 'Muy saludable':
          muySaludables.push(value);
          break;
        case 'Saludable':
          saludables.push(value);
          break;
        case 'No saludable':
          noSaludables.push(value);
          break;
        default:
          break;
      }
    });

    value.length = 0;
    value.push(muySaludables[Math.floor(Math.random() * muySaludables.length)]);
    value.push(saludables[Math.floor(Math.random() * saludables.length)]);
    value.push(noSaludables[Math.floor(Math.random() * noSaludables.length)]);
    value = value.sort(() => {return Math.random() - 0.5 });
    muySaludables.length = 0;
    saludables.length = 0;
    noSaludables.length = 0;
  });

  return ({collection});

}

export function patchUpdatedProperties(originalObj, modifiedObj){

  _.forIn(originalObj, (value, key) => {
    originalObj[key] = modifiedObj.hasOwnProperty(key) && value !== modifiedObj[key] ? modifiedObj[key] : value;
  });
}

export function isValidYearsOld(day) {

  let today = new Date();
  let selectedDay = new Date(day);

  let start = moment([today.getFullYear(), today.getMonth(), today.getDate()]);
  let end = moment([selectedDay.getFullYear(), selectedDay.getMonth(), selectedDay.getDate()]);
  let years = start.diff(end, 'years', true);

  DEBUG && console.log(OBJECT_ID + '@handleDayClick: Edad --->' + years);

  return years >= 18 && years <= 80;

}

export function isValidYearsKids(day) {

    let today = new Date();
    let selectedDay = new Date(day);

    let start = moment([today.getFullYear(), today.getMonth(), today.getDate()]);
    let end = moment([selectedDay.getFullYear(), selectedDay.getMonth(), selectedDay.getDate()]);
    let years = start.diff(end, 'years', true);

    DEBUG && console.log(OBJECT_ID + '@handleDayClick: Edad --->' + years);

    return years <= 17;

}

export function getStartingMoneyRandom(option) {
  let options = [300, 500, 1000, 1500, 3000];
  let startingMoney = 1000;

  switch (option) {
    /*case protocols.ANSWER_A:
      startingMoney = options[0];
      break;
    case protocols.ANSWER_B:
      startingMoney = options[1];
      break;
    case protocols.ANSWER_C:
      startingMoney = options[2];
      break;

    case protocols.ANSWER_D:
      startingMoney = options[3];
      break;

    case protocols.ANSWER_E:
      startingMoney = options[4];
      break;

    case protocols.ANSWER_F:
      startingMoney = options[3]; //options[Math.floor(Math.random() * options.length)];
      break;*/
    case '500':
      startingMoney = 500;
      break;
    case '1000':
      startingMoney = 1000;
      break;
    case '1500':
      startingMoney = 1500;
      break;
    case '2000':
      startingMoney = 2000;
      break;
    case '2500':
      startingMoney = 2500;
      break;
    case '3000':
      startingMoney = 3000;
      break;
    default:
      startingMoney = 3000;
      break;
  }
  return startingMoney;
}

export function createMessage() {
  let element = document.getElementById('messagePaginate');
  let node = document.createElement('P');
  let textnode = document.createTextNode(translate('paginate_msg'));
  node.setAttribute('id', 'mesgParagraph');
  node.appendChild(textnode);

  if ( element.lastElementChild === null ) {
    element.appendChild(node);
  }

}

export function removeMessage() {
  var element = document.getElementById('mesgParagraph');
  if (element) {
    element.parentNode.removeChild(element);
  }
}

export function doCallback(callback, message = null, ...values) {

  if ((callback) && (typeof callback === 'function')) {
    if (message) {
      callback(message, values);
    } else {
      callback(values);
    }
  } else {
    DEBUG && console.error('callback ' + callback + ' no es funcion');
  }
};

export function updateValuesInReduxTree(answersInTree, answersInStorage) {
  DEBUG && console.log(OBJECT_ID + '@updateValueInReduxTree: inicio');

  _.forEach(answersInStorage, o => {
    let questionInTree = _.find(answersInTree, ['id', o.id]);
    if (typeof questionInTree !== 'undefined' ) {
      DEBUG && console.log(OBJECT_ID + '@componentWillMount: Hallamos el elemento en el arbol, reemplazamos valor');
      questionInTree.answersSelected = o.answersSelected;
      _.forEach(questionInTree.answersSelected, o => {
        if (o.option) {
          //opcion existe, buscar como llave
          if (typeof questionInTree[o.option] === 'boolean') {
            //opción es booleana, invertir el valor
            questionInTree[o.option] = true;
          }
        } else {
          //INPUT
          //no existe la opción, poner el valor directamente
        }
      });
    }
  });

  return answersInTree;
};


export function updateValuesInStorage(storage, id, answersSelected) {
  DEBUG && console.log(OBJECT_ID + '@updateValuesInStorage: inicio');

  let answersInStorage = null;
  if (storage !== 'undefined') {
    answersInStorage = storage.answers.slice();
    let questionInStorage = _.find(answersInStorage, { id });
    if (typeof questionInStorage !== 'undefined') {
      questionInStorage.answersSelected = answersSelected;
    } else {
      answersInStorage.push({ id, answersSelected });
    }
  }

  return answersInStorage;
};

export function msieversion() {
    let ua = window.navigator.userAgent;

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return true;
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        return true;
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
       // Edge (IE 12+) => return version number
       return true;
    }

    return false;
};

export function spayGrat() {
  // Grayscale images only on browsers IE10+ since they removed support for CSS grayscale filter
if (getInternetExplorerVersion() >= 10){
  $('.container img').each(function(){
    var el = $(this);
    el.css({"position":"absolute"}).wrap("<div class='img_wrapper' style='display: inline-block'>").clone().addClass('img_grayscale').css({"position":"absolute","z-index":"5","opacity":"0"}).insertBefore(el).queue(function(){
      var el = $(this);
      el.parent().css({"width":this.width,"height":this.height});
      el.dequeue();
    });
    this.src = grayscaleIE10(this.src);
  });

  // Quick animation on IE10+
  $('.container img').hover(
    function () {
      $(this).parent().find('img:first').stop().animate({opacity:1}, 200);
    },
    function () {
      $('.img_grayscale').stop().animate({opacity:0}, 200);
    }
  );
};
}

function grayscaleIE10(src){
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var imgObj = new Image();
  imgObj.src = src;
  canvas.width = imgObj.width;
  canvas.height = imgObj.height;
  ctx.drawImage(imgObj, 0, 0);
  var imgPixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
  for(var y = 0; y < imgPixels.height; y++){
    for(var x = 0; x < imgPixels.width; x++){
      var i = (y * 4) * imgPixels.width + x * 4;
      var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
      imgPixels.data[i] = avg;
      imgPixels.data[i + 1] = avg;
      imgPixels.data[i + 2] = avg;
    }
  }
  ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
  return canvas.toDataURL();
};

export function getInternetExplorerVersion(){
  var rv = -1;
  if (navigator.appName == 'Microsoft Internet Explorer'){
    var ua = navigator.userAgent;
    var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
    rv = parseFloat( RegExp.$1 );
  }
  else if (navigator.appName == 'Netscape'){
    var ua = navigator.userAgent;
    var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
    rv = parseFloat( RegExp.$1 );
  }
  return rv;
};

export function getIndex(answer) {
  const INDEX_01 = 0;
  const INDEX_02 = 1;
  const INDEX_03 = 2;
  const INDEX_04 = 3;

  switch (answer) {
    case "answerA":
      return INDEX_01;
    case "answerB":
      return INDEX_02;
    case "answerC":
      return INDEX_03;
    case "answerD":
      return INDEX_04;
    case "answerE":
      return INDEX_04;
    case "answerF":
      return INDEX_04;
    default: return -1;
  }

}

export function getAnswerProducts(answer, product) {
  // si la respuesta es correcta retorna true, caso contrario respuesta incorrecta false
  if (answer === "answerA") {
    if (product.beneficio === 'Muy saludable') return true;
    return false;
  }

  if (answer === "answerB") {
    if (product.beneficio === 'Saludable') return true;
    return false;
  }

  if (answer === "answerC") {
    if (product.beneficio === 'No saludable') return true;
    return false;
  }

  if (answer === "answerD" || answer === "answerE" || answer === "answerF")
    return true;

  return false;
}

/**** Animated Checkboxes... Funciones para la creacion de svg con animacion ****/

const pathDefaults = {
	checkmark : ['M16.667,62.167c3.109,5.55,7.217,10.591,10.926,15.75 c2.614,3.636,5.149,7.519,8.161,10.853c-0.046-0.051,1.959,2.414,2.692,2.343c0.895-0.088,6.958-8.511,6.014-7.3 c5.997-7.695,11.68-15.463,16.931-23.696c6.393-10.025,12.235-20.373,18.104-30.707C82.004,24.988,84.802,20.601,87,16'],
	circle : ['M34.745,7.183C25.078,12.703,13.516,26.359,8.797,37.13 c-13.652,31.134,9.219,54.785,34.77,55.99c15.826,0.742,31.804-2.607,42.207-17.52c6.641-9.52,12.918-27.789,7.396-39.713 C85.873,20.155,69.828-5.347,41.802,13.379'],
};

const animDefaults = {
  checkmark : { speed : .2, easing : 'ease-in-out' },
  circle : { speed : .2, easing : 'ease-in-out' },
};

export function checkRadio() {
	if ( document.createElement('svg').getAttributeNS ) {
		let radiobxsCircle = Array.prototype.slice.call( document.querySelectorAll( 'form.ac-circle input[type="radio"]' ) );

		radiobxsCircle.forEach( element => {
				controlRadiobox( element, 'circle' );
			}
		);
	}
}

export function loadCheckRadio(element, type) {

	resetRadio( element );
	draw(element, type);
}

export function checkMark() {
	if ( document.createElement('svg').getAttributeNS ) {
		let checkbxsCheckmark = Array.prototype.slice.call( document.querySelectorAll( 'form.ac-checkmark input[type="checkbox"]' ) );

		checkbxsCheckmark.forEach( element => {
				controlCheckbox( element, 'checkmark' );
			}
		);

	}
}

export function loadCheckMark(element, type) {

	if( element.checked ) {
		draw( element, type )
	} else {
		reset ( element );
	}

}

function controlRadiobox( element, type ) {
	let svg = createSVGEl();
	element.parentNode.appendChild( svg );
	element.addEventListener( 'change', () => {
    DEBUG && console.log(OBJECT_ID + '@controlRadiobox: inicio --->');

    if ( element.id === 'questEighteenAnswerA' || element.id === 'questEighteenAnswerB' || element.id === 'questEighteenAnswerC' ||
         element.id === 'questEighteenAnswerD' || element.id === 'questEighteenAnswerE' || element.id === 'questEighteenAnswerF') {
      let option = element.getAttribute('data-option');

      if (option === protocols.ANSWER_B)
        return;
    }

		resetRadio( element );
		draw( element, type );
	} );
}

function controlCheckbox( element, type ) {
	let svg = createSVGEl();
	element.parentNode.appendChild( svg );

	element.addEventListener( 'change', () => {
		if( element.checked ) {
			draw( element, type );
		}
		else {
			reset( element );
		}
	} );
}

function createSVGEl( def ) {
	let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	if( def ) {
		svg.setAttributeNS( null, 'viewBox', def.viewBox );
		svg.setAttributeNS( null, 'preserveAspectRatio', def.preserveAspectRatio );
	}
	else {
		svg.setAttributeNS( null, 'viewBox', '0 0 100 100' );
	}
	svg.setAttribute( 'xmlns', 'http://www.w3.org/2000/svg' );
	return svg;
}

function draw( element, type ) {
	let paths = [], pathDef,
		animDef,
		svg = element.parentNode.querySelector( 'svg' );

	switch( type ) {
		case 'checkmark': pathDef = pathDefaults.checkmark; animDef = animDefaults.checkmark; break;
		case 'circle': pathDef = pathDefaults.circle; animDef = animDefaults.circle; break;
	};

	paths.push( document.createElementNS('http://www.w3.org/2000/svg', 'path' ) );

	for( let i = 0, len = paths.length; i < len; ++i ) {
		let path = paths[i];
		svg.appendChild( path );

		path.setAttributeNS( null, 'd', pathDef[i] );

		let length = path.getTotalLength();
		// Clear any previous transition
		//path.style.transition = path.style.WebkitTransition = path.style.MozTransition = 'none';
		// Set up the starting positions
		path.style.strokeDasharray = length + ' ' + length;
		if( i === 0 ) {
			path.style.strokeDashoffset = Math.floor( length ) - 1;
		}
		else path.style.strokeDashoffset = length;
		// Trigger a layout so styles are calculated & the browser
		// picks up the starting position before animating
		path.getBoundingClientRect();
		// Define our transition
		path.style.transition = path.style.WebkitTransition = path.style.MozTransition = 'stroke-dashoffset ' + animDef.speed + 's ' + animDef.easing + ' ' + i * animDef.speed + 's';
		// Go!
		path.style.strokeDashoffset = '0';
	}
}

function reset( element ) {
	Array.prototype.slice.call( element.parentNode.querySelectorAll( 'svg > path' ) ).forEach( ( element ) => { element.parentNode.removeChild( element ); } );
}

export function resetRadio( element ) {
	Array.prototype.slice.call( document.querySelectorAll( 'input[type="radio"][name="' + element.getAttribute( 'name' ) + '"]' ) ).forEach( ( element ) => {
		let path = element.parentNode.querySelector( 'svg > path' );
		if( path ) {
			path.parentNode.removeChild( path );
		}
	} );
}

export function esDeMexico(idPais){
  return idPais === 1;
}

export function esInternacional(idPais){
  return esDeMexico(idPais);
}

/********************************************************************************/
const currencyFormats = {
  1: {
    locale: "es-MX",
    options: { style: 'currency', currency: 'MXN' }
  },
  2: {
    locale: "es-AR",
    options: { style: 'currency', currency: 'ARS' }
  },
  3: {
    locale: "es-PA",
    options: { style: 'currency', currency: 'USD' }
  },
  4: {
    locale: "es-EC",
    options: { style: 'currency', currency: 'USD' }
  },
  5: {
    locale: "es-CO",
    options: { style: 'currency', currency: 'COP' }
  },
  6: {
    locale: "es-CR",
    options: { style: 'currency', currency: 'CRC' }
  }
}

export function formatoMoneda(idPais, monto){
  const {locale, options} = currencyFormats[idPais];

  return new Intl.NumberFormat(locale, options).format(monto);
}


// WEBPACK FOOTER //
// ./src/utilities/general-utils.js